// removed by extract-text-webpack-plugin
module.exports = {"wrap":"src-pages-resources-styles----general-module---wrap---1GWll pageWrap c-black textAlign-center pageWrap-l","subheading":"src-pages-resources-styles----general-module---subheading---3g7WC breakPointS-fontSize-xl breakPointM-fontSize-xxl breakPointM-lineHeight-xxl fontWeight-4 c-slate","heading":"src-pages-resources-styles----general-module---heading---2XeGj fontWeight-5 marginBottom-m fontSize-xxxl breakPointS-fontSize-xxxxl","spacing":"src-pages-resources-styles----general-module---spacing---3ax55"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/resources/styles/general.module.css
// module id = 758
// module chunks = 157636680307020